var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcRemoveCircleLined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.65 16.5C9.65 16.0858 9.98579 15.75 10.4 15.75H21.6C22.0142 15.75 22.35 16.0858 22.35 16.5C22.35 16.9142 22.0142 17.25 21.6 17.25H10.4C9.98579 17.25 9.65 16.9142 9.65 16.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 3.25C8.68223 3.25 2.75 9.18223 2.75 16.5C2.75 23.8178 8.68223 29.75 16 29.75C23.3178 29.75 29.25 23.8178 29.25 16.5C29.25 9.18223 23.3178 3.25 16 3.25ZM1.25 16.5C1.25 8.3538 7.8538 1.75 16 1.75C24.1462 1.75 30.75 8.3538 30.75 16.5C30.75 24.6462 24.1462 31.25 16 31.25C7.8538 31.25 1.25 24.6462 1.25 16.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRemoveCircleLined);
export default __webpack_public_path__ + "static/media/ic_remove_circle_lined.9ed656f49a8264f4157808c31d539e85.svg";
export { ForwardRef as ReactComponent };